import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import trial1 from '../../images/trial1.png';
import journey from '../../images/journey.png';

import trial3 from '../../images/trial3.png';
import user from '../../images/user.png';
import email from '../../images/email.png';
import phone from '../../images/phone.png';
import company from '../../images/company.png';
import country from '../../images/country.png';
import bed from '../../images/bed.png';

const Journey = (props) => {

    const [isOpen, setOpen] = useState(false)

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }

    return (
        <section className="journey_section section_space">
            <div className="container">
                <div className="row">
                   <div className="col-lg-12 text-center">
                       <h2>Start your Journey.</h2>
                       <p className='mb-0'>Find out how we can help you. Book in a chat with one of our hotel tech consultants</p>
                       <p className='mb-0'>or just sign up and test out what we offer for yourself.</p>
                    </div>

                    <div className="col-lg-12 text-center">
                        <ul className="btns_group unordered_list p-0 justify-content-center">
                            <li className='active'><Link to="/">Learn More</Link></li>
                            <li><Link to="/">Sign up now</Link></li>
                        </ul>
                    </div>

                    <div className="col-lg-12 text-center">
                        <img src={journey} alt="Techco - Trustpilot Review" />
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Journey;